module.exports = __webpack_public_path__ + "img/hospitium-02.1e994abb.jpg";